import {  useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import PromoSingle from "./PromoSingle";

const PromotionItem = () => {
  const { Id } = useParams();

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Promotion", link: "/promotion-list", active: true },
    { label: Id , link: `/promotion-list/${Id}`, active: true }, 
  ]; 
 

  return (
  <Container className="my-4"> 
    <BreadCrumb items={breadcrumbItems} />
    <PromoSingle backbtn={`/promotion-list`}/> 
  </Container> 

  );
}
export default PromotionItem; 